export class RequestConsultButton {
    constructor() {
        const requestConsultButton = document.querySelector(
            "#verder__request-button"
        ) as HTMLElement | null;

        if (requestConsultButton) {
            const delay = 2500; // in ms
            setTimeout(() => {
                requestConsultButton?.classList.remove("opacity-0");
                document.body.classList.add("max767:mb-[3.25rem]");
            }, delay);
        }

        const bottomFooter = document.querySelector(
            "#bottom-footer"
        ) as HTMLElement | null;
        if (bottomFooter && requestConsultButton) {
            const thresholds = Array.from(
                { length: 100 },
                (_, index) => index * 0.01
            );
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        // Calculate the translateY value based on the visible portion of the footer
                        const translateY =
                            entry.intersectionRatio *
                                bottomFooter.offsetHeight -
                            8;

                        // Apply the calculated translateY to the button
                        requestConsultButton.style.transform = `translateY(-${translateY}px)`;
                    });
                },
                {
                    threshold: thresholds, // Small threshold increments for smoother animation
                    rootMargin: "0px", // Adjust if needed to change when the observation starts
                }
            );

            observer.observe(bottomFooter);

            let lastScrollTop = 0;
            window.addEventListener("scroll", () => {
                const st =
                    window.pageYOffset || document.documentElement.scrollTop;

                const rect = bottomFooter.getBoundingClientRect();

                if (rect.top >= window.innerHeight && st < lastScrollTop) {
                    requestConsultButton.style.transform = "translateY(0)";
                }
                lastScrollTop = st <= 0 ? 0 : st;
            });
        }
    }
}
